import { useColorModeValue } from '@chakra-ui/react';

export const useColors = () => {
  // Main colors
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const headerBg = useColorModeValue('gray.50', 'whiteAlpha.50');
  const hoverBg = useColorModeValue('gray.50', 'whiteAlpha.50');
  const textColor = useColorModeValue('gray.700', 'white');

  // Input colors
  const inputColor = useColorModeValue('gray.800', 'whiteAlpha.900');
  const placeholderColor = useColorModeValue('gray.500', 'gray.400');

  // Filter section colors
  const filterSectionBg = useColorModeValue('white', 'navy.800');
  const filterBg = useColorModeValue('white', 'navy.800');
  const filterOptionHover = useColorModeValue('gray.100', 'navy.700');
  const filterOptionChecked = useColorModeValue('blue.50', 'navy.900');
  const filterHover = useColorModeValue('gray.50', 'whiteAlpha.100');
  const filterChecked = useColorModeValue('white', 'whiteAlpha.50');

  return {
    borderColor,
    headerBg,
    hoverBg,
    textColor,
    inputColor,
    placeholderColor,
    filterSectionBg,
    filterBg,
    filterOptionHover,
    filterOptionChecked,
    filterHover,
    filterChecked,
  };
};
